<template>
    <header>
        <div class="d-flex align-items-center pr-3 col-sm-2 pl-0" style="max-width:75%">
            <a class="px-3 py-0 d-flex align-items-center" href="/"><img class="img-sizes" :src="require('images/logo.svg')"></a>

            <div v-if="showLinks" class="d-flex align-items-center mr-4">
                <a class="mr-3" :href="piktomirPath"><img class="img-sizes" src="../assets/images/websitesIcons/piktomir_icon.png"></a>

                <a :href="mireraPath"><img class="img-sizes" src="../assets/images/websitesIcons/mirera_icon.png"></a>
            </div>
        </div>

        <div class="d-flex justify-content-between pr-0">
            <div class="buttons-header-container">
                <div class="icon-container icon-substrate ml-auto" :class="{'mr-2': hideDropdown}" @click="changeLocale">
                    <img class="header-icon" :src="require(`images/headerIcons/locales/${$i18n.locale}.svg`)">
                </div>

                <template v-if="!hideDropdown">
                    <template v-if="profile">
                        <div class="d-flex h-100">
                            <a v-if="$route.query.redirectWebsites" class="header-link h-100" @click="redirectWebsites">
                                <div class="icon-container icon-substrate"><img class="header-icon" :src="require('images/headerIcons/home.svg')"></div></a>

                            <div class="d-flex justify-content-center align-items-center mx-0 h-100">
                                <b-dropdown class="dropdown-bg h-100 d-flex align-items-center justify-content-end h-100" offset="25" toggle-class="header-dropdown-button" menu-class="header-dropdown-menu">
                                    <template #button-content>
                                        <img class="header-icon" :src="require('images/headerIcons/user.svg')">

                                        <p class="header-text mb-0 pl-2 mobile-hide" style="padding-right: 0.75rem">
                                            {{ `${profile.surname} ${profile.name}` }}
                                        </p>

                                        <img class="ml-auto" :src="require('images/headerIcons/arrow.svg')">
                                    </template>

                                    <b-dropdown-item v-if="profile.type === $defines.ACCOUNT_TYPES.ADMIN" class="header-dropdown-item header-text item-substrate" to="/admin">
                                        {{ $t('button.adminPanel') }}
                                    </b-dropdown-item>

                                    <b-dropdown-item class="header-dropdown-item header-text item-substrate" to="/account">
                                        {{ $t('button.settings') }}
                                    </b-dropdown-item>

                                    <b-dropdown-item class="header-dropdown-item header-text item-substrate" @click="logout">
                                        {{ $t('button.logout') }}
                                    </b-dropdown-item>
                                </b-dropdown>
                            </div>
                        </div>
                    </template>

                    <router-link v-else class="header-link icon-substrate ml-auto mr-2 h-100" to="/login" style="color: black; height: 27px; border-radius: 5px">
                        <img class="header-icon" :src="require('images/headerIcons/login.svg')">

                        <p class="header-text mb-0 pl-1">
                            {{ $t('button.login') }}
                        </p>
                    </router-link>
                </template>
            </div>
        </div>
    </header>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import { USER_LOGOUT } from 'actions/user';
    import { SWITCH_LOCALE } from 'actions/i18n';
    import Paths from './mixins/Paths';
    import UrlUtils from './mixins/UrlUtils';

    export default {
        name: 'HeaderMenu',

        mixins: [
            Paths,
            UrlUtils
        ],

        computed: {
            ...mapGetters('user', [ 'profile' ]),

            hideDropdown() {
                return this.$route.name === 'PermissionsRequest' && !this.profile || this.$route.name === 'Login';
            },

            showLinks() {
                return !(this.$route.name === 'ConfirmAccount') && !(this.$route.query.redirect_uri);
            },

            inverseLocale() {
                switch (this.$i18n.locale) {
                    case this.$defines.LOCALES.RU:
                        return this.$defines.LOCALES.EN;
                    case this.$defines.LOCALES.EN:
                        return this.$defines.LOCALES.RU;
                    default:
                        return this.$defines.LOCALES.RU;
                }
            }
        },

        methods: {
            ...mapActions({
                logout: `user/${USER_LOGOUT}`
            }),

            changeLocale() {
                this.$store.dispatch(`i18n/${SWITCH_LOCALE}`, this.inverseLocale);
            },

            redirectWebsites() {
                this.openUrl(this.$route.query.redirectWebsites, false, false);
            }
        }
    };
</script>

<style scoped>
    .img-sizes {
        height: 2rem;
        width: 2rem
    }

    .header-link,
    .header-link:hover {
        height: 100%;
        display: flex;
        align-items: center;
        text-decoration: none;
        cursor: pointer;
        color: black;
        font-size: 14px;
    }

    .icon-container {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        min-width: 23px;
    }

    .icon-substrate {
        border-radius: 10px !important;
        cursor: pointer;
        padding-left: 0.5rem;
        padding-right: 0.5rem;
    }

    .icon-substrate:hover,
    .icon-substrate:active {
        background-color: #E6EEF3 !important;
        border-radius: 10px !important;
        height: 85% !important;
    }

    .item-substrate {
      cursor: pointer;
      height: 32px;
    }

    .item-substrate:hover,
    .item-substrate:active {
      background-color: #E6EEF3 !important;
    }

    .header-icon {
        width: 14px;
        height: 14px;
    }

    .header-text {
        font-size: 14px;
    }

    /deep/ .header-dropdown-button,
    /deep/ .header-dropdown-button:hover,
    /deep/ .header-dropdown-button:active {
        display: flex !important;
        align-items: center !important;
        background-color: transparent !important;
        color: black !important;
        outline: none !important;
        box-shadow: none !important;
        border: none !important;
        padding: 0 0.5rem 0 0.5rem !important;
        margin-right: 0.5rem;
        border-radius: 10px !important;
        height: 85% !important;
        min-width: 140px !important;
    }

    /deep/ .header-dropdown-button:hover,
    /deep/ .header-dropdown-button:active {
        background-color: #E6EEF3 !important;
        border-radius: 10px !important;
        height: 85% !important
    }

    /deep/ .header-dropdown-button::after {
        content: none !important;
    }

    /deep/ .dropdown-bg.show {
        background-color: white !important;
        border-radius: 0 !important;
    }

    /deep/ .b-dropdown > .dropdown-toggle > img:not(.header-icon) {
        transition: .3s ease all
    }

    /deep/ .b-dropdown.show > .dropdown-toggle > img:not(.header-icon) {
        transform: rotate(180deg);
    }

    /deep/ .header-dropdown-menu {
        width: calc(100% - 0.5rem) !important;
        border: none !important;
        border-radius: 10px !important;
        padding: 0 !important;
        margin: 0 !important;
        transform: translate3d(0, 2.5rem, 0) !important;
        background: #FFFFFF !important;
        min-width: 140px !important;
        overflow: hidden;
        display: block !important;
        max-height: 0 !important;
        transition: max-height .3s ease-in-out;
        position: absolute !important;
        top: 0.2rem !important;
        will-change: transform !important;
    }

    /deep/ .header-dropdown-menu.show {
        max-height: 96px !important;
    }

    /deep/ .dropdown-item {
        overflow: hidden;
        text-align: start;
        padding-left: 2rem !important;
        padding: 0.3rem 1.5rem;
    }

    /deep/ .header-dropdown-item a {
        display: flex;
        align-items: center;
        height: 32px;
        border-radius: 0 !important;
    }

    /deep/ .header-dropdown-item:hover a {
        background-color: #E6EEF3 !important;
        color: #000000;
    }

    header {
        display: flex;
        background-color: #FFFFFF !important;
        box-shadow: 0 0 8px;
        width: 100%;
        justify-content: space-between;
        max-width: 100vw;
        height: 2.5rem !important;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        z-index: 1030;
    }

    .buttons-header-container {
        display: flex;
        align-items: center;
        margin-left: auto;
        justify-content: flex-end;
        height: 2.5rem;
    }

    @media screen and (max-width: 576px) {
        /deep/ .header-dropdown-menu {
            left: -80px !important;
        }

        /deep/ .header-dropdown-button,
        /deep/ .header-dropdown-button:hover,
        /deep/ .header-dropdown-button:active {
            min-width: 60px !important;
        }

        .mobile-hide {
            display: none !important;
            visibility: hidden !important;
        }
    }
</style>
